const APP_ORIGIN = process.env.REACT_APP_ORIGIN;
export const protocolSetupPath = `${APP_ORIGIN}protocol-data-service/v1/setup`;
export const esysDataServicePath = `${APP_ORIGIN}esys-data-service/v1`;
export const requestBrowserPath = `${protocolSetupPath}/protocol/browse`;
export const requestValidationPath = `${protocolSetupPath}/request/validate`;
export const saveProtocolInfoPath = `${protocolSetupPath}/requests/part-a/protocol`;
export const saveProtocolInfoPathB = `${protocolSetupPath}/requests/part-b/protocol`;
export const protocolPath = `${APP_ORIGIN}protocol-data-service/v1/protocols`;
export const leadGroupLov = `${protocolSetupPath}/protocols/leadgroups`;
export const leadGroupProtocolLov = (lpo) =>
  `${protocolSetupPath}/leadgroups/${lpo}/protocols`;
export const raveStudyGroupsLov = (lpo) =>
  `${protocolSetupPath}/leadgroups/${lpo}/ravestudygroups`;
export const getPersonRole = `${protocolSetupPath}/persons/roles/browse`;
export const raveSetup = `${protocolSetupPath}/requests/part-a/rave`;
export const openSetup = `${protocolSetupPath}/requests/part-a/open`;
export const regulatorySetupPath = `${protocolSetupPath}/requests/part-b/regulatory`;
export const getOpenSetupData = (psOpenId) =>
  `${protocolSetupPath}/requests/part-a/open/${psOpenId}`;
export const countries = `${APP_ORIGIN}esys-data-service/v1/esys/countries`;
export const getDocUploadUrl = (context) =>
  `${APP_ORIGIN}esys-data-service/v1/esys/service/${context}/doc/upload`;
export const submitProtocolPath = `${protocolSetupPath}/request`;
export const deleteFilePath = (docId) =>
  `${APP_ORIGIN}esys-data-service/v1/esys/service/EDK/doc/${docId}/PROTSETUP`;
export const openRaveSubmittedUrl = `${protocolSetupPath}/requests/part-a/signoff/submitted`;
export const validateProtocolSetupRequest = (requestNumber, formPartType) =>
  `${protocolSetupPath}/${requestNumber}/copyrequest/${formPartType}/validate`;
export const copyRequestPath = `${protocolSetupPath}/request/copy`;
export const defaultErrorMessage =
  "Unable to complete the request. Contact CTSU Help Desk, ctsucontact@westat.com.";
export const groupTestingUrl = `${protocolSetupPath}/requests/part-a/signoff/grouptesting`;
export const ctsuTestingUrl = `${protocolSetupPath}/requests/part-a/signoff/ctsutesting`;
export const signoffReminderUrl = `${protocolSetupPath}/requests/part-a/signoff/reminder`;
export const uatSetupUrl = `${protocolSetupPath}/requests/part-a/signoff/uatsetup`;
export const pendingSignOffUrl = `${protocolSetupPath}/requests/part-a/signoff/pending`;
export const completeSignOffUrl = `${protocolSetupPath}/requests/part-a/signoff/completed`;
export const regulatorySignOffSubmitted = `${protocolSetupPath}/requests/part-b/signoff/submitted`;
export const regulatorySignOffInProgress = `${protocolSetupPath}/requests/part-b/signoff/regulatoryadmin`;
export const regulatorySignOffAdditionalSignOff = `${protocolSetupPath}/requests/part-b/signoff/irocadmin`;
export const regulatorySignoffReminderUrl = `${protocolSetupPath}/requests/part-b/signoff/reminder`;

export const saveChangeHistoryUrl = `${esysDataServicePath}/esys/history`;
export const statusUpdateUrl = `${protocolSetupPath}/request/status/update`;
export const documentByIdUrl = (documentId) => `${APP_ORIGIN}protocol-data-service/v1/documents/id/${documentId}`;